import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import codes from 'country-calling-code';
import { find } from 'lodash';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const DialogTitle = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogTitle);

const DialogActions = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  content: {
    width: 325,
    padding: theme.spacing(),
  },
  field: {
    display: 'flex',
    flexDirection: 'row',
  },
  countryCode: {
    marginRight: theme.spacing(),
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmButtonText?: string;
  cancelButtonText?: string;
  title: string;
  onConfirm: (mobileNum: string) => void;
  onCancel?: () => void;
  contentText: string;
  intialCountryCode: string;
};

export default function AlertExistingMemberMobileDialog({
  cancelButtonText,
  confirmButtonText,
  onClose,
  onCancel,
  onConfirm,
  open,
  title,
  contentText,
  intialCountryCode,
}: Props) {
  const classes = useStyles();
  const [mobileNum, setMobileNum] = useState('');
  const [helperText, setHelperText] = useState('');
  const [countryCode, setCountryCode] = useState(intialCountryCode);

  const handleSubmit = () => {
    const callingCode = find(codes, function (code) {
      return code.isoCode2 === countryCode;
    });
    if (mobileNum.length === 0) {
      setHelperText('Required');
    } else {
      if (callingCode) {
        onConfirm('+' + callingCode.countryCodes + ' ' + mobileNum.trim());
      }
    }
  };

  const handleCountryCode = (event: React.ChangeEvent<{ value: unknown }>) => {
    setCountryCode(event.target.value as string);
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.content}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{contentText}</DialogContentText>
          <div className={classes.field}>
            <Select
              value={countryCode}
              onChange={handleCountryCode}
              className={classes.countryCode}
            >
              {codes.map((code) => (
                <MenuItem value={code.isoCode2} key={code.isoCode2}>
                  {'+' + code.countryCodes + ' ' + code.country}
                </MenuItem>
              ))}
            </Select>
            <TextField
              label={''}
              value={mobileNum}
              onChange={(e) => {
                setMobileNum(e.target.value);
                setHelperText('');
              }}
              error={helperText.length > 0}
              helperText={helperText}
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            color="primary"
            autoFocus
            disabled={mobileNum.length === 0}
          >
            {confirmButtonText || 'Confirm'}
          </Button>
          {cancelButtonText && onCancel && (
            <Button onClick={onCancel} variant="contained" autoFocus>
              {cancelButtonText}
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
}
